import logo from "../../assests/images/landing-page/logo.png";
const Logo = () => {
  return <img src={logo} alt="logo" width="30px" height="auto" />;
};

export default Logo;
